/* global BigInt */
export const filterKeys = [
  'query',
  'group_id',
  'status',
  'date_from',
  'date_to',
  'payment_from',
  'payment_to',
];
export const readFilters = query =>
  Object.fromEntries(
    filterKeys.map(key => [
      key,
      typeof query[key] === 'string' ? query[key] : '',
    ])
  );
export function readPage(query) {
  const value = typeof query.page === 'string' ? query.page : '';
  return /^\d{1,7}$/.test(value) && Number(value) > 0 ? Number(value) : 1;
}
export function listQuery(filters, page = 1, view = 'paid') {
  const result = { view };
  filterKeys.forEach(key => {
    const value = String(filters[key] || '').trim();
    if (value) result[key] = value;
  });
  if (page > 1) result.page = String(page);
  return result;
}
export const statusLabels = {
  active: 'Действует',
  scheduled: 'Запланировано',
  expired: 'Срок истёк',
  exhausted: 'Лимит исчерпан',
  revoked: 'Отключено',
  pending_identity: 'Ожидает первого сообщения',
  pending_review: 'Размещения на проверке',
  identity_conflict: 'Требуется подтверждение пользователя',
};
export const userLabel = row =>
  row.username ? `@${row.username}` : `TG User ID: ${row.telegram_user_id}`;
export function dateLabel(value, last = false) {
  return new Intl.DateTimeFormat('ru-RU', { timeZone: 'Europe/Moscow' }).format(
    new Date(new Date(value).getTime() - (last ? 1 : 0))
  );
}
export const periodLabel = row =>
  `${dateLabel(row.starts_at)} — ${dateLabel(row.ends_at, true)}`;
export const moneyLabel = row =>
  `${(row.paid_amount_minor / 100).toLocaleString('ru-RU')} ₽`;

export function paymentDateLabel(row) {
  if (row.paid_amount_minor === 0) return 'Без оплаты';
  return row.payment_date
    ? row.payment_date.split('-').reverse().join('.')
    : 'Не указана';
}
export function paymentTotalLabel(minor = '0') {
  const amount = BigInt(minor);
  return `${(amount / 100n).toLocaleString('ru-RU')},${(amount % 100n).toString().padStart(2, '0')} ₽`;
}
